<div class="navigation">
  <button class="menu-toggle" type="button" (click)="menuOpen = !menuOpen" [attr.aria-expanded]="menuOpen" aria-controls="participant-links" aria-label="Toggle menu"><i class="fa fa-bars" aria-hidden="true"></i></button>
  <nav id="participant-links" aria-label="Participant navigation" [class.open]="menuOpen">
    <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
    <a routerLink="/store" routerLinkActive="active">Store</a>
    <a routerLink="/recipients" routerLinkActive="active">Recipients</a>
    <ng-container *ngIf="authenticated$ | async">
      <a routerLink="/streaker-central" routerLinkActive="active">Streaker Central</a>
      <a *ngIf="commerce.resumableOrder$ | async as order" routerLink="/checkout" [queryParams]="order.orderId > 0 ? { order: order.orderId } : {}">Complete order</a>
    </ng-container>
    <ng-container *ngTemplateOutlet="menuItems; context: { $implicit: menus$ | async }"></ng-container>
  </nav>
</div>
<ng-template #menuItems let-items>
  <ng-container *ngFor="let menu of items">
    <details *ngIf="menu.children?.length; else leaf" class="submenu">
      <summary>{{ menu.display }}</summary>
      <div class="submenu-items">
        <dw-menu-link [menu]="menu" menuLocation="top" className="streakers-nav-link"></dw-menu-link>
        <ng-container *ngTemplateOutlet="menuItems; context: { $implicit: menu.children }"></ng-container>
      </div>
    </details>
    <ng-template #leaf><dw-menu-link [menu]="menu" menuLocation="top" className="streakers-nav-link"></dw-menu-link></ng-template>
  </ng-container>
</ng-template>
